<template>
    <div>

        <el-row style="margin-bottom:10px;">
            <el-col :span="18" class='flex'>
                <el-input v-model="getDepartmentList_data.dtName" placeholder="请输入战队名称" clearable size='small'
                    style="max-width:200px;" />
                <el-button v-click.getDepartmentList type="primary" icon='el-icon-search' size='small'
                    style='margin-left:10px;'>搜索
                </el-button>
            </el-col>
            <el-col :span="6">
                <el-button v-if='addUser' @click="$form('addMultiUsersAll'), tabledataAll = [], row = {}" size='small'
                    type="primary" style="float:right" icon='el-icon-circle-plus'>批量添加学员
                </el-button>
                <el-button v-if="addDepartment" @click=" $form('addDepartment')" size='small' type="primary"
                    style="float:right" icon='el-icon-circle-plus'>添加战队
                </el-button>
            </el-col>
        </el-row>

        <mytable :tableColums='tableColums_getDepartmentList' api='getDepartmentList' xupdateapi='updateDepartment'
            :height="H - 165">
        </mytable>

        <myform :viewobj='{
            addDepartment: ["新增战队", "el-icon-circle-plus"],
            updateDepartment: ["修改战队", "el-icon-edit-outline"],
            $succeed$: getDepartmentList
        }' @closed="$form('updateDepartment', 'reset')">

            <hide slot='dtId' />
            <hide slot='projectId' />
        </myform>

        <myform view.lookUsers='学员' id='FormTop' top='20px' @opened='arguments[0].title += " | @" + row.dtName'
            @close='$form("lookUsers", "hide")'>
            <el-button v-if='addUser' @click="$form('addMultiUsersAll'), tabledataAll = []" size='small' type="primary"
                style="float:right" icon='el-icon-circle-plus'>批量添加
            </el-button>
            <el-button v-if='addUser' @click="$form('addUser', { puAuthModel: 1 })" size='small' type="primary"
                style="float:right" icon='el-icon-circle-plus'>添加账号
            </el-button>
            <el-button v-if="deleteUser" @click="doMultiDelete" size='small' type="primary" style="float:right"
                icon='el-icon-delete'>批量删除
            </el-button>
            <mytable ref="getProjectUserListTable" :tableColums='tableColums_getProjectUserList'
                api='getProjectUserList::userId' xupdateapi='updateUser' :height="H - 165">
            </mytable>
        </myform>
        <myform :viewobj='{
            addUser: ["新增账号信息", "el-icon-circle-plus"],
            updateUser: ["修改账号信息", "el-icon-edit-outline"],
            $succeed$: getProjectUserList
        }' @close='$form("updateUser", "reset")' @confirm='myformUser'>
            <!-- 类型id -->
            <template v-slot:yutId="{ Myformdata }">
                <el-select v-model='Myformdata.yutId' clearable>
                    <el-option v-for="item in getUserTypeList_data.data || []" :key="item.yutId" :label="item.yutName"
                        :value="item.yutId">
                    </el-option>
                </el-select>
            </template>
            <template v-slot:puAuthModel="{ Myformdata }">
                <el-radio-group v-model="Myformdata.puAuthModel">
                    <el-radio :label="1">通用版(学、练)</el-radio>
                    <el-radio :label="2">定制版(学、练、ai工具)</el-radio>
                    <el-radio :label="3">定制版(全部功能)</el-radio>
                    <el-radio :label="4">定制版(练)</el-radio>
                </el-radio-group>
            </template>
            <hide slot='userId' />
            <hide slot='postId' />
            <hide slot='roleListString' />
            <hide slot='dtId' />
            <hide slot='loginApp' />
            <hide slot='loginPc' />
        </myform>
        <myform view.addMultiUsersAll="批量导入学员" @opened='arguments[0].title += " | @" + "所有战队网格"'
            @close='$form("addMultiUsersAll", "hide")'>
            <el-row>
                <el-col :span="4" style="min-width:100px;">
                    <el-button type="primary" @click="toDownExcel">下载<i
                            class="el-icon-download el-icon--right"></i></el-button>
                </el-col>
                <el-col :span="20">
                    <el-upload ref="uploadAll" action="#" :limit="1" :auto-upload="false" :show-file-list="true"
                        :on-change="onChangeContent">
                        <el-button type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
                    </el-upload>
                </el-col>
            </el-row>
            <el-table :data="tabledataAll" v-if="(tabledataAll || '').length > 0" max-height="400">
                <el-table-column prop="dtName" label="战队网格" width="120">
                </el-table-column>
                <el-table-column prop="name" label="用户名" width="120">
                </el-table-column>
                <el-table-column prop="yutName" label="用户类型" width="120">
                </el-table-column>
                <el-table-column prop="account" label="工号" width="80">
                </el-table-column>
                <el-table-column prop="phone" label="手机号" width="120">
                </el-table-column>
                <el-table-column prop="status" fixed="left" label="状态" width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == '失败'" style="color:red;">{{ scope.row.status }}</span>
                        <span v-else>{{ scope.row.status }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="statusMsg" fixed="left" label="账号描述" width="140">
                </el-table-column>
                <el-table-column prop="targetJs" label="签约总家数" width="100">
                </el-table-column>
                <el-table-column prop="targetJe" label="签约总金额" width="100">
                </el-table-column>
                <el-table-column prop="targetSl" label="签约总数量" width="100">
                </el-table-column>
                <el-table-column prop="targetVisitor" label="每日走访目标" width="100">
                </el-table-column>
                <el-table-column prop="targetMoney" label="每日开单金额目标" width="100">
                </el-table-column>
            </el-table>
        </myform>
    </div>
</template>

<script>
import myhttp from '../../utils/myhttp';
export default {
    data() {
        return {
            tabledataAll: [],
            mainType: [],
            dtId: null,
            thedtId: "",
            tableColums_getDepartmentList: {
                $selection: false,

                dtName: '战队名称',
                dtUsers: '战队人数',
                dtPriority: '排序',
                createtime: '创建时间',

                $operation: [
                    '操作', 200,
                    this.updateDepartment && `@text: 编辑#warn
             @click: $form("updateDepartment",$row)
            `,
                    this.deleteDepartment && `@text: 删除#danger
             @click: _confirm('确定要删除该战队吗?')
                     .trigger('deleteDepartment',{dtId:$row.dtId})
                     .trigger('getDepartmentList')
            `,
                    `@text: 人员#success
           @click: $form( 'lookUsers', $this.row = $row ),getProjectUserList({dtId:$row.dtId,postId:5})
          `
                    ,
                ],
            },
            tableColums_getProjectUserList: {
                $selection: true,
                userName: '用户名',
                puAuthModel: ['版本', , '@v-if: 1:通用版(学、练)#danger, 2:定制版(学、练、ai工具)#success, 3:定制版(全部功能)#success, 4:定制版(练)#success'],
                userAccount: '工号',
                userPhone: '手机号',
                yutName: '类型',
                createtime: '创建时间|sortable',
                userRemark: ["账号描述", 120],
                $operation: (this.updateUser || this.deleteUser) && [
                    '操作', 200,
                    this.updateUser && `@text: 编辑#success
           @click: $form("updateUser",$row)
          `,
                    this.deleteUser && `@text: 删除#danger
           @click: _confirm('确定要删除该账号吗?')
                   .trigger('deleteUser',{userListString:$row.userId+""})
                   .trigger('getProjectUserList')
          `,

                ],

            },

        };
    },

    watch: {

    },

    methods: {
        async onChangeContent(files, fileList) {
            const table = await this.doupload(files.raw);
            this.tabledata = table.data.data.data;
            this.tabledataAll = table.data.data.data;
            this.getProjectUserList();
            if (this.$refs.upload) {
                this.$refs.upload.clearFiles();  //清空文件
            }
            if (this.$refs.uploadAll) {
                this.$refs.uploadAll.clearFiles();  //清空文件
            }
        },
        doupload: async function (file) {
            let param = new FormData(); // 创建form对象
            param.append("file", file); // 通过append向form对象添加数据
            if (this.row && this.row.dtId) {
                param.append("dtId", this.row.dtId);
            }
            const loading = $Loading();
            const responseData = await myhttp.postFileUsers("/opportunity/auth-file/upload", param);
            loading.close();
            if (responseData.data.result == "success") {
                this.$message({
                    type: "success",
                    message: "上传成功!"
                });
            } else {
                this.$message({
                    type: "error",
                    message: "上传失败!"
                });
            }
            return responseData
        },
        async doMultiDelete() {
            const selection = Object.keys(this.$refs.getProjectUserListTable.$MyTableCache);
            if (selection.length === 0) return alertWarn('请选择您要删除的数据！');
            if (await this._confirm(`确定要删除这${selection.length}条吗?`)) {
                this.deleteUser({ userListString: selection.join() })
                    .result(result => {
                        if (result.data.result == "success") {
                            alertSuccess(result.data.msg);
                            this.getProjectUserList({ dtId: this.row.dtId, postId: 5 })
                        } else {
                            alertError(result.data.msg);
                        }
                    })
            };
        },
        toDownExcel() {
            myhttp.downloadFile("https://trainapp.aojuai.com/trainai/excel/user.xlsx", "用户.xlsx");
        },
        myformUser(submit, Myformdata) {
            Myformdata.dtId = this.row.dtId;
            Myformdata.postId = 5;
            Myformdata.loginApp = 1;
            Myformdata.loginPc = 2;
            submit();
        },
    },

    async created() {
        this.getUserTypeList({ pageSize: 0 });
        this.getProjectUserLists({ postId: 5, pageSize: 0 });
        this.getDepartmentList();

    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/DivisionalManagement/DivisionalManagement.vue